import {
  Iconify
} from "./chunk-LKUMTIYE.js";

// src/IconifyButton.tsx
import { template as _$template } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { getOwner as _$getOwner } from "solid-js/web";
import { spread as _$spread } from "solid-js/web";
import { mergeProps as _$mergeProps } from "solid-js/web";
import { Show, splitProps } from "solid-js";
var _tmpl$ = /* @__PURE__ */ _$template(`<wa-button max-w-fit w-full>`, true, false, false);
var IconifyButton = (allProps) => {
  const [props, restProps] = splitProps(allProps, ["size", "icon", "text", "hint", "children", "onClick"]);
  return (() => {
    var _el$ = _tmpl$();
    _$spread(_el$, _$mergeProps(restProps, {
      get onClick() {
        return props.onClick;
      },
      get alt() {
        return props.hint;
      },
      get title() {
        return props.hint;
      },
      get ["aria-label"]() {
        return props.hint;
      },
      get size() {
        return props.size ?? "small";
      }
    }), false, true);
    _el$._$owner = _$getOwner();
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return !!props.icon;
      },
      get children() {
        return _$createComponent(Iconify, {
          get name() {
            return props.icon;
          }
        });
      }
    }), null);
    _$insert(_el$, () => props.text || props.children, null);
    return _el$;
  })();
};

export {
  IconifyButton
};
//# sourceMappingURL=chunk-GHVDX3FD.js.map